// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"f36731ec","452":"fa024ad5","858":"ae6a647b","885":"4f39f1ed"}[chunkId] + ".chunk.js";
};